import React, { Component } from 'react'
import Footer from '../../components/Footer'
import Mainmenu from '../../components/Mainmenu'
import Navbar from '../../components/Navbar'

import PostContent from './PostContent'
export default class Post extends Component {

    

    render() {

        let id = this.props.match.params.id;
        return (
            <div className="wrapper">
                <Navbar />
                <Mainmenu />
                <PostContent id={id} />
                <Footer />

            </div>


        )
    }
}
